import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })

export class ImageUrls {
  noDataFound = 'assets/images/top-icon/no-data-found.svg'
  calenderIcon = 'assets/images/top-icon/calender-Icon.svg'
  filterIcon = 'assets/images/top-icon/filter-icon.svg'
  clearFilterIcon = 'assets/images/top-icon/clearfilter.svg'
  rightArrowIcon = 'assets/images/icon-right.png'
  warningIcon = 'assets/images/warning-icon.svg'
  customTableIcon = 'assets/images/icon-left.svg'
  detailErIcon = 'assets/images/detail-ER.svg'
  detailEravailIcon = 'assets/images/er_avail.svg'
  availabiliyAvailIcon = 'assets/images/availbility-avail.svg'
  closeIcon = 'assets/images/close-icon.svg'
  plusIcon = 'assets/images/plus-icon.svg'
  deleteIcon = 'assets/images/delete.svg'
  dowloandIcon = 'assets/images/dowloand.svg'
  fileImage = 'assets/images/file.svg'
  refreshImage = 'assets/images/refresh.svg'
  clockIcon = 'assets/images/clock.svg'
  greenTickIcon = 'assets/images/green-tick.svg'
  redCloseIcon = 'assets/images/red-close-icon.svg'
  noUserAccessImage = 'assets/images/new-user.png'
  noClearingInstance = 'assets/images/no-clearing-course.png'
  searchIcon = 'assets/images/search-icon.svg'
  campusAvailTickIcon = 'assets/images/icon-tick-avail.svg'
  dollarIcon = 'assets/images/icon-dollar.svg'
  blockIcon = 'assets/images/icon-block.svg'
}
